module.exports = {"310106006":"江宁路街道","310106011":"石门二路街道","310106012":"南京西路街道","310106013":"静安寺街道","310106014":"曹家渡街道","310106015":"天目西路街道","310106016":"北站街道","310106017":"宝山路街道","310106018":"共和新路街道","310106019":"大宁路街道","310106020":"彭浦新村街道","310106021":"临汾路街道","310106022":"芷江西路街道","310106101":"彭浦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310106.json
// module id = 910
// module chunks = 0